<div class="relative w-full h-full overflow-hidden grid grid-cols-2 gap-4">
  <div class="col-span-1">
    <ngx-charts-pie-chart
      #pieChart
      class="w-full h-full"
      [customColors]="customColors"
      [scheme]="colorScheme"
      [results]="chartData"
      [gradient]="gradient"
      [legend]="false"
      [legendTitle]="legendTitle"
      [explodeSlices]="explodeSlices"
      [labels]="labels"
      [doughnut]="doughnut"
      [arcWidth]="arcWidth"
      [activeEntries]="activeEntries"
      [tooltipDisabled]="tooltipDisabled"
      [labelFormatting]="labelFormatting"
      [trimLabels]="trimLabels"
      [maxLabelLength]="maxLabelLength"
      [tooltipText]="tooltipText"
      [animations]="animations"
      (select)="onSelect($event)"
      (activate)="onActivate($event)"
      (deactivate)="onDeactivate($event)"
    >
    </ngx-charts-pie-chart>
  </div>

  <!-- Custom legend in the right section -->
  <div class="col-span-1 flex flex-col justify-center mr-8" *ngIf="showLegend">
    <div class="space-y-2 divide-y divide-gray-300 border-t border-b border-gray-300">
      <div
        *ngFor="let item of chartData"
        class="flex items-center gap-4 text-sm cursor-pointer hover:opacity-80 h-[32px]"
        (click)="onSelect(item)"
      >
        <div
          class="rounded-full flex-shrink-0 w-[14px] h-[16px]"
          [style.background-color]="getColorForItem(item.name)"
        ></div>
        <span class="text-gray-700 text-[16px] truncate">{{item.name}}</span>
        <span class="text-gray-500 ml-auto text-[16px]">{{item.value}}</span>
      </div>
    </div>


    <div class="flex items-center gap-1 text-sm mt-4 whitespace-nowrap">
      <mat-icon class="!text-[18px] !w-[18px] !h-[18px] align-middle material-icons-outlined">
        info
      </mat-icon>
      <span class="gray-400-text">Click slices to see those devices</span>
    </div>
  </div>
</div>